import { Tab } from '@reach/tabs';
import classNames from 'classnames';
import * as React from 'react';
import { Text } from 'wix-style-react';
import s from './Tabs.scss';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { useTranslation } from 'react-i18next';
import { RootStore, withInjectedRootStore } from 'providers';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { Experiments, PlanType } from 'enums';

interface TabButtonProps extends InjectedExperimentsProps {
  isInSale: boolean;
  dataTestId: string;
  title: string;
  description: string;
  rootStore: RootStore;
}

const TabButtonComp: React.FC<TabButtonProps> = ({
  isInSale,
  dataTestId,
  title,
  description,
  rootStore,
  experiments,
}) => {
  const { t } = useTranslation();
  const { theme } = usePageModeContext();
  const { planType } = rootStore.appStore;
  const isSelected = dataTestId.includes(planType);
  const isEnterpriseTabEnabled = experiments.enabled(
    Experiments.AddEnterpriseTab,
  );
  const isBusinessTabMiddle =
    isEnterpriseTabEnabled && dataTestId === 'business-tab-button';
  return (
    <>
      <Tab
        as='div'
        className={classNames(
          s.tab,
          {
            [s.saleColor]: isInSale,
            [s.leftBorder]:
              isBusinessTabMiddle && planType === PlanType.Enterprise,
            [s.rightBorder]:
              isBusinessTabMiddle && planType === PlanType.Website,
          },
          theme,
        )}
        data-testid={dataTestId}
      >
        <div className={s.tabTitles}>
          <Text
            size='medium'
            skin={isSelected ? 'premium' : 'standard'}
            className={classNames({
              'sale-orange-color-editor-x': isInSale && isSelected,
            })}
          >
            <span className={classNames({ [s.title]: isSelected })}>
              {t(title)}
            </span>
          </Text>
          <Text
            skin={isSelected ? 'premium' : 'standard'}
            size='small'
            className={classNames(s.tabDescription, {
              'sale-orange-color-editor-x': isInSale && isSelected,
            })}
          >
            {t(description)}
          </Text>
        </div>
      </Tab>
    </>
  );
};

export const TabButton = withInjectedRootStore(withExperiments(TabButtonComp));
